import { BOOLEAN } from '@/plugins/sdk/fields'

export default {
  label: 'No',
  operator: 'is',
  fields: [ BOOLEAN ],
  isValidValue (value) {
    return value === 0
  }
}
